import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/badge'
import { useState } from 'react'
import { ChevronDown, ChevronRight, Tags } from 'lucide-react'

interface TagCount {
  tag: string
  count: number
}

interface Props {
  tags: TagCount[]
}

export default function TagCloud({ tags }: Props) {
  const [expanded, setExpanded] = useState(true)

  if (tags.length === 0) return null

  return (
    <div className="mt-3 px-1">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 mb-1.5 w-full"
      >
        {expanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Tags className="h-3 w-3" />
        Tags
      </button>
      {expanded && (
        <div className="flex flex-wrap gap-1">
          {tags.map(({ tag, count }) => (
            <Badge
              key={tag}
              variant="secondary"
              className="text-[10px] cursor-pointer hover:bg-gray-200"
              onClick={() => router.visit(`/notes?tag=${encodeURIComponent(tag)}`)}
            >
              {tag} <span className="ml-0.5 text-gray-400">{count}</span>
            </Badge>
          ))}
        </div>
      )}
    </div>
  )
}
